import React from "react";
import PropTypes from "prop-types";
import { snakeCase } from "lodash";
import { Link } from "react-router-dom";
import { getUserDropdownItems } from "../utils";
import useLocalLicense from "../../licensing/hooks/useLocalLicense";
import RlNavigationDropdownItem from "./components/RlNavigationDropdownItem";
import RlNavigationSubmenuItem from "./components/RlNavigationSubmenuItem";
import RlNavigationIcon from "./components/RlNavigationIcon";

const RlNavigationUserItem = ({ user, linksReloadDocumentOverride }) => {
  const { isLocalLicenseValidOrOnline } = useLocalLicense();
  const userItems = getUserDropdownItems(
    user.isAdmin,
    isLocalLicenseValidOrOnline
  );
  return (
    <RlNavigationDropdownItem
      title={<RlNavigationIcon name="user" />}
      id="user"
    >
      <RlNavigationSubmenuItem
        className="dimmed fst-italic"
        noLink
        testId="main_nav_username"
      >
        @{user.name}
      </RlNavigationSubmenuItem>
      {userItems
        .filter(item => item.visible)
        .map(item => {
          const { label, linkReloadsDocument, visible, ...rest } = item;
          return (
            <RlNavigationSubmenuItem
              key={label}
              testId={snakeCase(`main_nav_menu_item_${label}`)}
            >
              <Link
                {...rest}
                reloadDocument={
                  linkReloadsDocument || linksReloadDocumentOverride
                }
              >
                {label}
              </Link>
            </RlNavigationSubmenuItem>
          );
        })}
    </RlNavigationDropdownItem>
  );
};

RlNavigationUserItem.propTypes = {
  user: PropTypes.shape({
    isAdmin: PropTypes.bool,
    name: PropTypes.string
  }),
  linksReloadDocumentOverride: PropTypes.bool
};

export default RlNavigationUserItem;
